import React, {
  useRef,
  useEffect,
  useCallback,
  useState,
  useMemo
} from "react";
import "./style.less";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Modal, Icon, Button } from "semantic-ui-react";
import {
  setSelectedPolygonId,
  editSelectedFence,
  deleteReqSelectedFence,
  viewAssignedBuddies,
  viewAssignedWarehouses
} from "../../../../redux/geofence/actions";
import { geofenceCategoryValueToTextMap } from "../utils";
import { useHistory, useRouteMatch } from "react-router-dom";
import { countOrderWithin } from "../../../../utils/order-count-fence";

function GeofenceEditPopup() {
  const history = useHistory();
  const match = useRouteMatch("/city/:cityName/");
  const selectedPolygon = useSelector(({ geofence }) =>
    geofence.selectedPolygonId
      ? geofence.visibleGeofences.find(
          e => e._id === geofence.selectedPolygonId
        )
      : null
  );
  const selectedPolygonId = useSelector(
    ({ geofence }) => geofence.selectedPolygonId,
    shallowEqual
  );
  const dispatch = useDispatch();
  const domRef = useRef();
  const [deleteConfirmBox, setDeleteConfirmBox] = useState(false);
  const orderpins = useSelector(
    ({ geofence }) => geofence.orderpins,
    shallowEqual
  );

  const orderCount = useMemo(() => {
    if (selectedPolygon && orderpins) {
      return countOrderWithin(selectedPolygon.geometry);
    }
    return 0;
  }, [orderpins, selectedPolygon]);

  const onEditIconClickHandler = useCallback(() => {
    dispatch(editSelectedFence());
    history.push(`${match.url}/geofences/update`);
  }, [dispatch, match, history]);

  const showDeleteConfirmBox = useCallback(() => {
    setDeleteConfirmBox(true);
  }, [setDeleteConfirmBox]);

  const closeDeleteConfirmBox = useCallback(() => {
    setDeleteConfirmBox(false);
  }, [setDeleteConfirmBox]);

  const deleteButtonHandler = useCallback(() => {
    setDeleteConfirmBox(false);
    dispatch(deleteReqSelectedFence());
  }, [dispatch, setDeleteConfirmBox]);

  useEffect(() => {
    if (domRef.current && selectedPolygon) {
      domRef.current.focus();
    }
  }, [selectedPolygon]);

  const onBlurHandler = useCallback(() => {
    if (!deleteConfirmBox) {
      dispatch(setSelectedPolygonId(null));
    }
  }, [dispatch, deleteConfirmBox]);

  const viewAssignedBuddiesHandler = useCallback(() => {
    dispatch(viewAssignedBuddies(selectedPolygonId));
  }, [dispatch, selectedPolygonId]);

  const viewAssignedWarehouseHandler = useCallback(() => {
    dispatch(viewAssignedWarehouses(selectedPolygonId));
  }, [dispatch, selectedPolygonId]);

  return selectedPolygon ? (
    <div className={"GeofenceEditPopup"}>
      <Modal
        onClose={closeDeleteConfirmBox}
        size="tiny"
        open={deleteConfirmBox}
      >
        <Modal.Content className="center-text">
          <Icon name="trash alternate outline" size="huge" />
          <br />
          <br />
          <p>Are you sure you want to delete this geofence ?</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={closeDeleteConfirmBox} inverted primary>
            No, Cancel.
          </Button>
          <Button onClick={deleteButtonHandler} primary>
            Yes I am sure.
          </Button>
        </Modal.Actions>
      </Modal>
      <div tabIndex={-1} onBlur={onBlurHandler} ref={domRef}>
        <div className="fenceDetails">
          <h3>
            {selectedPolygon.properties.name}
            {orderCount ? ` - Order Count: ${orderCount}` : ""}
          </h3>
          <p className={selectedPolygon.properties.fenceCategory}>
            {
              geofenceCategoryValueToTextMap[
                selectedPolygon.properties.fenceCategory
              ]
            }
          </p>
        </div>
        <div className="updateCta">
          {(selectedPolygon.properties.fenceCategory === "BUDDY_BLOCK" ||
            selectedPolygon.properties.fenceCategory === "WAREHOUSE_FENCE") && (
            <Icon
              onClick={viewAssignedWarehouseHandler}
              name="warehouse"
              size="large"
            />
          )}

          {selectedPolygon.properties.fenceCategory === "BUDDY_BLOCK" && (
            <Icon
              onClick={viewAssignedBuddiesHandler}
              name="users"
              size="large"
            />
          )}
          <Icon onClick={onEditIconClickHandler} name="pencil" size="large" />
          {/*<Icon
            onClick={showDeleteConfirmBox}
            name="trash alternate outline"
            size="large"
          />*/}
        </div>
      </div>
    </div>
  ) : null;
}

GeofenceEditPopup.defaultProps = {};

GeofenceEditPopup.propTypes = {};

export default GeofenceEditPopup;
